// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tn2vCDdrl9PwSfAIEQ_t {
    font-family: "Suranna", sans-serif;
    font-weight: 400;
    font-size: 72px;
    line-height: 64px;
}

.AVp96Fd1cx3XRlZC4XQD {
    font-family: "Suranna", sans-serif;
    font-weight: 400;
    font-size: 36px;
    line-height: 42px;
}

.hexm5lj8CvhFNfE0ZuLM {
    font-family: "Suranna", sans-serif;
    font-weight: 400;
    font-size: 48px;
    line-height: 64px;
}

.AGeQPFYxBnWs2S1lUQwk {
    font-family: "Suranna", sans-serif;
    font-weight: 400;
    font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./src/typographies.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".header {\n    font-family: \"Suranna\", sans-serif;\n    font-weight: 400;\n    font-size: 72px;\n    line-height: 64px;\n}\n\n.description {\n    font-family: \"Suranna\", sans-serif;\n    font-weight: 400;\n    font-size: 36px;\n    line-height: 42px;\n}\n\n.subheader {\n    font-family: \"Suranna\", sans-serif;\n    font-weight: 400;\n    font-size: 48px;\n    line-height: 64px;\n}\n\n.input {\n    font-family: \"Suranna\", sans-serif;\n    font-weight: 400;\n    font-size: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Tn2vCDdrl9PwSfAIEQ_t`,
	"description": `AVp96Fd1cx3XRlZC4XQD`,
	"subheader": `hexm5lj8CvhFNfE0ZuLM`,
	"input": `AGeQPFYxBnWs2S1lUQwk`
};
export default ___CSS_LOADER_EXPORT___;
